import { render, staticRenderFns } from "./DataExportNew.vue?vue&type=template&id=3ab06758&"
import script from "./DataExportNew.vue?vue&type=script&lang=ts&"
export * from "./DataExportNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports